import { PedologyInteractor, PedologyRequest, PedologyStructRequest} from "../../Coordinator/Pedology/PedologyInteractor";

export class PedologyViewModel {
    private interactor: PedologyInteractor;

	constructor() {
		this.interactor = new PedologyInteractor();
	}

    public fetchSave(obj: any): PromiseLike<any> {
        var request = new PedologyRequest(
            obj["sgeppedologia"] ? parseInt(obj["sgeppedologia"]) : 0,
            obj["nome"] ? obj["nome"] : ""
        )
        
        return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res()
			}, e => {
				return rej(e)
			});
		})
    }

    public fetchDataOne(obj: any): PromiseLike<any> {
        var request = new PedologyStructRequest(
            obj["sgeppedologia"] ? parseInt(obj["sgeppedologia"]) : 0
        )
        
        return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
    }
}